"use strict";
// https://document.microcms.io/manual/field-extension
exports.__esModule = true;
